import { Model as ORMModel, attr, fk } from 'redux-orm'
import { Types } from '@fedsim/actions'

export class Draft extends ORMModel {
    static get fields() {
        return {
            id: attr(),

            date: attr({ getDefault: () => new Date() }),
            cost: attr({ getDefault: () => 30 }),
            pick: attr({ getDefault: () => 1 }),
            complete: attr({ getDefault: () => false }),

            brandId: fk({
                to: 'Brand',
                as: 'brand',
                relatedName: 'DraftBrand'
            }),
            wrestlerId: fk({
                to: 'Wrestler',
                as: 'wrestler',
                relatedName: 'DraftWrestler'
            })
        }
    }

    static reducer(action, Draft, session) {
        let item
        switch (action.type) {
            case Types.RESET:
            case 'RESET_DRAFTS':
                session.Draft.all()
                    .toModelArray()
                    .forEach(item => item.delete())
            break
          case Types.GENERATE_DRAFTS:
            action?.payload?.forEach(newItem => {
              session.Draft.upsert(newItem)
            })
            break
            case Types.DELETE_WRESTLER:
                session?.Draft?.all()
                    .toModelArray()
                    .forEach(item => {
                        if (
                            action?.payload?.id &&
                            item.wrestlerId === action?.payload?.id
                        ) {
                            item.delete()
                        }
                    })
                break
            case 'ADD_DRAFT':
                item = action.payload.id ? Draft.withId(action.payload.id) : false
                if (!item) {
                    Draft.upsert(action.payload)
                }
                break
            case 'UPDATE_DRAFT':
                item = Draft.withId(action.payload.id)
                if (item) {
                    item.update(action.payload)
                }
                break
            case 'REMOVE_DRAFT':
            case 'DELETE_DRAFT': {
                Draft.withId(action.payload.id).delete()
                break
            }
        }
    }
}


export default Draft
